module.exports = __webpack_public_path__ + "static/media/TW_PromotionCard-print_Front.a9be8bfc.jpg";